import { render, staticRenderFns } from "./conversation-count-column.vue?vue&type=template&id=5ffbb552"
import script from "./conversation-count-column.vue?vue&type=script&lang=js"
export * from "./conversation-count-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ffbb552')) {
      api.createRecord('5ffbb552', component.options)
    } else {
      api.reload('5ffbb552', component.options)
    }
    module.hot.accept("./conversation-count-column.vue?vue&type=template&id=5ffbb552", function () {
      api.rerender('5ffbb552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/outgoing-number/conversation-count-column.vue"
export default component.exports